import { render, staticRenderFns } from "./MassiveReserveTransferList.vue?vue&type=template&id=2bc8fcf5&"
import script from "./MassiveReserveTransferList.vue?vue&type=script&lang=js&"
export * from "./MassiveReserveTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports